export const handleChangeDataPageCheckoutCart = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_CHECKOUT_CART', name, value
});